import {Injectable} from '@angular/core';


/**
 * Service to check the capabilities of the current execution environment.
 * It provides methods to determine if certain browser features are supported.
 */
@Injectable({
    providedIn: 'root'
})
export class EnvironmentCapabilities {

    /**
     * Checks if the environment supports creating and using Blobs for downloads.
     * This includes checking for Blob support, URL.createObjectURL, and the 'download' attribute on anchor elements.
     *
     * @returns True if Blobs and downloads are supported, false otherwise.
     */
    canUseBlob(): boolean {
        try {
            const a = document.createElement('a');
            return (
                typeof Blob !== 'undefined' &&
                typeof URL !== 'undefined' &&
                typeof URL.createObjectURL === 'function' &&
                'download' in a
            );
        } catch {
            return false;
        }
    }

    /**
     * Checks if the environment supports IndexedDB.
     *
     * @returns True if IndexedDB is available, false otherwise.
     */
    hasIndexedDB(): boolean {
        return (
            typeof window !== 'undefined' &&
            'indexedDB' in window &&
            window.indexedDB != null
        );
    }

    /**
     * Checks if the environment is running within a Cordova wrapper.
     *
     * @returns True if Cordova is available on the window object, false otherwise.
     */
    canUseCordova(): boolean {
        return typeof window !== 'undefined' && !!(window as any).cordova;
    }
}
